import moment from 'moment';

const STORED_FORMAT = 'DD/MM/YYYY';

export function parseStoredDate(value) {
  if (!value) {
    return moment.invalid();
  }

  const trimmed = String(value).trim();
  const slashParsed = moment(trimmed, STORED_FORMAT, true);
  if (slashParsed.isValid()) {
    return slashParsed.startOf('day');
  }

  const isoParsed = moment(trimmed, 'YYYY-MM-DD', true);
  if (isoParsed.isValid()) {
    return isoParsed.startOf('day');
  }

  return moment.invalid();
}

export function formatStoredDate(momentValue) {
  if (!momentValue?.isValid?.()) {
    return '';
  }
  return momentValue.clone().startOf('day').format(STORED_FORMAT);
}
